/** Shared GA4 parameter keys (privacy-safe; never room codes or PII). */
export const AnalyticsParams = Object.freeze({
  MATCH_TYPE: "match_type",
  BEST_OF: "best_of",
  IS_PRIVATE: "is_private",
  DURATION_SEC: "duration_sec",
  TOTAL_POINTS: "total_points",
  WINNER_SIDE: "winner_side",
  ROLE: "role",
  GAME_NUMBER: "game_number",
  IS_OFFLINE: "is_offline",
  DEVICE_TYPE: "device_type",
  IS_PWA: "is_pwa",
  INTERVAL_KIND: "interval_kind",
  SWAP_KIND: "swap_kind",
  SHARE_CHANNEL: "share_channel",
  ERROR_KIND: "error_kind",
  REASON: "reason",
  UPDATE_SOURCE: "update_source",
});
